export const NOUVEAUTES=[
    {
        title:"Calandrier de l'année universitaire 2023-2024" ,
        date:'31 Octobre 2023',
        ecrivain:'Ali bougzala',

    } ,
    {
        title:"Calandrier de l'année universitaire 2023-2024" ,
        date:'31 Octobre 2023',
        ecrivain:'Ali bougzala',

    } 
    ,
    {
        title:"Calandrier de l'année universitaire 2023-2024" ,
        date:'31 Octobre 2023',
        ecrivain:'Ali bougzala',

    }  ,
    {
        title:"Calandrier de l'année universitaire 2023-2024" ,
        date:'31 Octobre 2023',
        ecrivain:'Ali bougzala',

    }  ,
    {
        title:"Calandrier de l'année universitaire 2023-2024" ,
        date:'31 Octobre 2023',
        ecrivain:'Ali bougzala',

    }  ,
    {
        title:"Calandrier de l'année universitaire 2023-2024" ,
        date:'31 Octobre 2023',
        ecrivain:'Ali bougzala',

    } 


]